import React from 'react';
import ReactExport from 'react-data-export';
import '../forms/Button.css';
import { getLocalizedDateTime, getLocalizedString } from '../../localization/LocalizedString';
import '../../views/ServiceReport.css';
import formatSeconds from './TimeFormat';

const { ExcelFile } = ReactExport;
const { ExcelSheet, ExcelColumn } = ExcelFile;

const sortByDate = (items) => {
  return items.slice().sort((a, b) => {
    const aDate = new Date(a.totalEndTime);
    const bDate = new Date(b.totalEndTime);

    if (aDate > bDate) {
      return -1;
    }
    if (bDate > aDate) {
      return 1;
    }
    return 0;
  });
};

// A bit hackish way to get overall results.
const calculateOverallValues = (tasks) => {
  // copy and sort
  const tasksWithOverallValues = sortByDate(tasks.slice(0));

  // calculate overall values
  let overallDestinationDuration = 0;
  let overallServiceDuration = 0;
  for (let i = 0; i < tasks.length; i += 1) {
    const task = tasks[i];

    // calculate service time from the related tasks
    let serviceDuration = 0;
    for (let j = 0; j < task.relatedTasks.length; j += 1) {
      serviceDuration += task.relatedTasks[j].durationSeconds;
    }
    task.serviceDuration = serviceDuration;

    let serviceName = "";
    if (task.service != null && task.service.length > 0) {
      serviceName = task.service[0].name;
    }
    task.serviceName = serviceName;

    // service time
    overallServiceDuration += serviceDuration;

    // destination time
    overallDestinationDuration += task.totalDuration;
  }

  // create overall values
  tasksWithOverallValues.push({
    totalDuration: overallDestinationDuration,
    customer: {},
    serviceDuration: overallServiceDuration,
  });
  return tasksWithOverallValues;
};

const ExportGroupedTaskExcelButton = ({ translate, data, currentLanguage }) => {
  const tasksWithOverallValues = calculateOverallValues(data);
  const overallDurationLabel = translate('service_report.column_task.overallDuration')
    + ' ' + translate('service_report.column_task.timeFormat');
  const workDurationLabel = translate('service_report.column_task.workDuration')
     + ' ' + translate('service_report.column_task.timeFormat');
  const overallDurationSecLabel = translate('service_report.column_task.overallDuration')
    + ' ' + translate('service_report.column_task.secFormat');
  const workDurationSecLabel = translate('service_report.column_task.workDuration')
     + ' ' + translate('service_report.column_task.secFormat');
  return (
    <ExcelFile hideElement filename={translate('service_report.search.type_grouped')}>
      <ExcelSheet data={tasksWithOverallValues} name="Sheet1">
        <ExcelColumn label={translate('service_report.column_task.date')} value={(col) => getLocalizedDateTime(new Date(col.totalEndTime), currentLanguage)} />
        <ExcelColumn label={overallDurationLabel} value={(col) => formatSeconds(col.totalDuration)} />
        <ExcelColumn label={workDurationLabel} value={(col) => formatSeconds(col.serviceDuration)} />
        <ExcelColumn label={translate('service_report.column_task.diff')} value={(col) => formatSeconds(col.totalDuration - col.serviceDuration)} />
        <ExcelColumn label={overallDurationSecLabel} value={(col) => col.totalDuration} />
        <ExcelColumn label={workDurationSecLabel} value={(col) => col.serviceDuration} />
        <ExcelColumn label={translate('service_report.column_task.diff')} value={(col) => col.totalDuration - col.serviceDuration} />
        <ExcelColumn label={translate('service_report.column_task.customer')} value={(col) => col.customer.name} />
        <ExcelColumn label={translate('service_report.column_task.end_customer')} value="companyName" />
        <ExcelColumn label={translate('service_report.column_task.address')} value="streetAddress" />
        <ExcelColumn label={translate('service_report.column_task.city')} value="city" />
        <ExcelColumn label={translate('service_report.column_task.service')} value={(col) => getLocalizedString(col.serviceName, currentLanguage)} />
        <ExcelColumn label={translate('service_report.column_task.user')} value="userId" />
      </ExcelSheet>
    </ExcelFile>
  );
};

export default ExportGroupedTaskExcelButton;



// WEBPACK FOOTER //
// ./src/components/servicereport/ExportGroupedTaskExcelButton.js